import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserList from './user_list';
import UserDetail from './user_detail';

class Users extends Component {
  componentDidMount(){
    
  
  }
  UNSAFE_UNSAFE_componentWillReceiveProps(nextProps){
    //console.log(nextProps);
    if(nextProps.group!=='Administrator'&&nextProps.group!==''){
      this.context.router.history.push('/');
    }
  }
  render() {
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <UserList/>;
    }else{
      if(params.id===undefined){
        view = <UserDetail/>;
      }else{
        view = <UserDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Users.contextTypes = {
  router: PropTypes.object
};

export default Users;
